/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';

import WindowEventsHandler from '../../services/WindowEventsHandler';

import NextSteps from '../steps/finish/NextSteps';

/* eslint max-len: 0 */
export default class ThankYouPage extends Component {
    componentDidMount() {
        WindowEventsHandler.disableUnloadMessage();
    }

    render() {
        return (
            <div className="app__message-page__container">
                <h1 className="vouchedfor-brand font-size-20">Thank You!</h1>
                <p>
                    Your request is now being processed by our team.
                </p>
                <NextSteps />
                <div className="push-down-10">
                    If you'd like to amend or cancel your request please email:
                </div>
                <a className="link-primary" href="mailto:consumer_support@vouchedfor.co.uk">
                    consumer_support@vouchedfor.co.uk
                </a>
                <div className="push-up-10 push-down-50">
                    Or call us on <a href="tel:02031110583">0203 111 0583</a>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/steps/ThankYouPage.jsx